<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  data() { return {} },
  mounted() {
    Vue.nextTick(() => {
      // Animation management.
      this.registerAnimation();
    });
  },
  methods: {
    isTouchDevice: Fandom.isTouchDevice,
  },
  computed: { }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :style="theme" :class="[contentType, {'d-none d-lg-block': !content.show_mobile}]" class="inview_animate" navbar-secondary-component>
    <nav class="navbar position-static navbar-expand" :class="`navbar-expand${content.show_mobile ? '' : '-lg'}`" id="secondary-nav">
      <div class="navbar-nav mx-auto px-3 py-2">
        <li
          :key="index"
          :ref="`auxiliary-item-${index}`"
          v-for="(item, index) in content.items.filter(el => !el.hidden)"
          class="nav-item px-2 px-xl-3 d-flex align-items-center"
        > 
          <a
            v-if="item.url"
            :target="getTarget(item.url)"
            :href="item.url.url"
            :class="`link-${content.theme}`"
          >
            {{item.url.title}}
          </a>
        </li>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
[navbar-secondary-component] {

  font-weight: bold;
  font-size: .75rem !important;
  background-color: var(--theme-background);

  .navbar {
    overflow-y: auto;
  }

  ::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
    height: 0;
  }
  
  a {
    text-decoration: none;
    color: var(--theme-color);
    transition: color .25s;
    padding: 3px 0;
    white-space: nowrap;

    &:hover {
      color: $gray-700;
      &.link-dark {
        color: $gray-400;
      }
    }
  }
}
</style>